import axios from "axios";

class Auth {
  constructor() {
    this.auth = axios.create({
      baseURL: process.env.REACT_APP_PUBLIC_DOMAIN_3,
      withCredentials: true
      });
  }

  signup(user) {
    const { username, password } = user;
    return this.auth
      .post("/auth/signup", { username, password })
      .then(({ data }) => data);
  }

  login(user) {
    const { username, password } = user;
    return this.auth
      .post("/auth/login", { username, password })
      .then(({ data }) => data);
    } 

  createUser(user) {
    const { username, password, role } = user;
    return this.auth
      .post("/auth/users", { username, password, role })
      .then(({ data }) => data);
  }

  logout() {
    return this.auth
      .post("/auth/logout", {})
      .then(response => response.data);
  }

  me() {
    return this.auth
    .get("/auth/me")
    .then(response => response.data);
  }

  // private () {
  //   return this.auth.get("/")
  //   .then(response => response.data);
  // }

  read () {
    return this.auth.get("/auth/private")
      .then(({data}) => data);
  }
}

const auth = new Auth();

export default auth;